import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import About from "./About";
import Experience from "./Experience";
import Projects from "./Projects";
import Certifications from "./Certifications";
import ExtaCurricular from "./Extracurricular";
import Contact from "./Contact";
import femaleicon from "./assets/femaleicon.webp";
import { GoMail } from "react-icons/go";
import { AiOutlineLinkedin } from "react-icons/ai";
import { TbBrandLeetcode } from "react-icons/tb";
import { ImGithub } from "react-icons/im";
import { IoLocationOutline } from "react-icons/io5";

function Navbar() {
  const [selectedNavItem, setSelectedNavItem] = useState("About");
  const [activeLink, setActiveLink] = useState("About");
  const [isContactVisible, setIsContactVisible] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsContactVisible(true);
      }
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleNavItemClick = (item) => {
    setSelectedNavItem(item);
    setActiveLink(item);
  };

  const toggleContactVisibility = () => {
    if (window.innerWidth <= 768) {
      setIsContactVisible(!isContactVisible);
    }
  };

  const contentComponents = {
    About: () => <About />,
    Resume: () => <Experience />,
    Projects: () => <Projects />,
    Certifications: () => <Certifications />,
    Exta: () => <ExtaCurricular />,
    Contact: () => <Contact />,
  };

  return (
    <Router>
      <div className="main-container">
        <div className="justify-content-center">
          <div className="sidebar">
            <div className="sidebar-sticky">
              <div className="info-content">
                <img className="femalelogo" src={femaleicon} alt="Logo" />
                <div className="info-content2">
                  <h3 className="name">Radha Thakare</h3>
                  <p className="title">Software Developer at Wavel.ai</p>
                </div>
              </div>
              <div className="separator"></div>

              {/* Show Contact button (top-right of sidebar) */}
              <button className="show-contact-button" onClick={toggleContactVisibility}>
                {isContactVisible ? "Hide Contact" : "Show Contact"}
              </button>

              {/* Conditional rendering of contact list */}
              {isContactVisible && (
                <div className="contact-list flex-column mt-5">
                  <div className="icon">
                    <div className="img-icon">
                      <GoMail className="icons" style={{ color: "hsl(45, 100%, 72%)" }} />
                    </div>
                    <div className="text-icon">
                      <p className="contact-title">Email</p>
                      <p className="desc">thakareradha2001@gmail.com</p>
                    </div>
                  </div>
                  <div className="icon">
                    <div className="img-icon">
                      <AiOutlineLinkedin className="icons" style={{ color: "hsl(45, 100%, 72%)" }} />
                    </div>
                    <div className="text-icon">
                      <a href="https://www.linkedin.com/in/radha-thakare/">
                        <p className="contact-title">LinkedIn</p>
                        <p className="desc">View</p>
                      </a>
                    </div>
                  </div>
                  <div className="icon">
                    <div className="img-icon">
                      <TbBrandLeetcode className="icons" style={{ color: "hsl(45, 100%, 72%)" }} />
                    </div>
                    <div className="text-icon">
                      <a href="https://leetcode.com/radhathakare/">
                        <p className="contact-title">Leetcode</p>
                        <p className="desc">View</p>
                      </a>
                    </div>
                  </div>
                  <div className="icon">
                    <div className="img-icon">
                      <ImGithub className="icons" style={{ color: "hsl(45, 100%, 72%)" }} />
                    </div>
                    <div className="text-icon">
                      <a href="https://github.com/radhathakare">
                        <p className="contact-title">Github</p>
                        <p className="desc">View</p>
                      </a>
                    </div>
                  </div>
                  <div className="icon">
                    <div className="img-icon">
                      <IoLocationOutline className="icons2" style={{ color: "hsl(45, 100%, 72%)" }} />
                    </div>
                    <div className="text-icon">
                      <p className="contact-title">Location</p>
                      <p className="desc">Bengaluru, India</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="navbar1 navbar-expand-lg">
          <div className="resumeheader">
            <div className="article-title">{selectedNavItem}</div>
            <div className="navbar-container">
              {Object.keys(contentComponents).map((item, index) => (
                <ul className="navbar-list" key={index}>
                  <div className="nav-item">
                    <button
                      className="nav-link"
                      onClick={() => handleNavItemClick(item)}
                      style={{
                        color: activeLink === item ? "#FFDB70" : "#FFFFFF",
                      }}
                    >
                      {item}
                    </button>
                  </div>
                </ul>
              ))}
            </div>
          </div>

          <div className="content">
            {contentComponents[selectedNavItem] && contentComponents[selectedNavItem]()}
          </div>
        </div>
      </div>
    </Router>
  );
}

export default Navbar;
